import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhirefortarkari() {



const cardData =
{
  keyword: 'Tempo Traveller Hire for Tarkarli',
  heading: 'Sanavi Travels: Tempo Traveller Hire for Tarkarli',
  headingDescription: 'Sanavi Travels provides reliable Tempo Traveller hire for Tarkarli, perfect for families, friends, corporate teams, and group travelers planning a relaxed and scenic Konkan beach getaway. Our well-maintained Tempo Travellers with skilled drivers ensure a safe, comfortable, and memorable outstation journey from Pune and nearby cities to Tarkarli.',

  top: 'Top Travel Experiences & Attractions While Visiting Tarkarli',

  topPlaces: [
    {
      title: 'Tarkarli Beach & Coastal Experience',
      description: 'Tarkarli Beach is one of Maharashtra’s most pristine coastal destinations, famous for its crystal-clear waters, white sand, and peaceful surroundings. Hiring a Tempo Traveller for Tarkarli allows groups to travel together comfortably while carrying luggage, beach gear, food supplies, and personal items without space constraints. The long Konkan journey becomes enjoyable as passengers can relax, socialize, and admire the scenic countryside. Group travel reduces fatigue, improves coordination, and ensures everyone arrives refreshed and ready to enjoy the beach atmosphere. Families, friends, and corporate teams benefit from stress-free travel and organized arrivals at beach resorts and homestays.'
    },
    {
      title: 'Water Sports & Adventure Activities',
      description: 'Tarkarli is well known for snorkeling, scuba diving, boating, and water sports. A Tempo Traveller makes it easy for groups to reach activity points together on time, without worrying about multiple vehicles or parking. The spacious seating and smooth suspension help travelers remain energized for adventure activities. Group travel also ensures better safety coordination, especially for students, corporate teams, and first-time visitors exploring marine activities.'
    },
    {
      title: 'Sindhudurg Fort Visit',
      description: 'A visit to Sindhudurg Fort is an essential part of any Tarkarli itinerary. Traveling by Tempo Traveller allows the entire group to reach ferry points together and manage sightseeing schedules efficiently. Elders and children benefit from comfortable travel, while guides and coordinators can manage the group easily. The shared journey enhances cultural learning and makes the heritage visit more organized and enjoyable.'
    },
    {
      title: 'Family Beach Vacation',
      description: 'Tarkarli is ideal for peaceful family vacations away from crowded tourist hubs. A Tempo Traveller ensures that all family members, including elders and kids, travel together in a calm and secure environment. Comfortable seating, air-conditioning options, and professional drivers reduce travel stress, making the long outstation journey pleasant and safe for everyone.'
    },
    {
      title: 'Corporate Retreats & Team Outings',
      description: 'Many corporate groups choose Tarkarli for team outings, retreats, and relaxation programs. Tempo Traveller hire supports disciplined, punctual, and professional travel. Employees can interact, bond, and unwind during the journey itself, creating a positive team experience even before reaching the destination.'
    },
    {
      title: 'Friends Group Picnic & Weekend Trips',
      description: 'Friends planning weekend getaways or extended beach trips to Tarkarli prefer Tempo Travellers for convenience and affordability. Traveling together enhances enjoyment, allows music and conversations, and removes the hassle of coordinating multiple vehicles. The journey becomes a memorable part of the overall trip.'
    },
    {
      title: 'Wedding & Family Function Travel',
      description: 'For destination weddings or family functions near Tarkarli, Tempo Travellers are ideal for guest transportation. They help manage arrivals, departures, and group movement efficiently, reducing logistical stress during important occasions.'
    },
    {
      title: 'Student & Educational Tours',
      description: 'Educational institutions often organize coastal and marine study tours to Tarkarli. Tempo Traveller hire allows teachers to supervise students easily, maintain discipline, and ensure safety throughout the journey while keeping the group together.'
    },
    {
      title: 'Overnight & Multi-Day Outstation Tours',
      description: 'Tarkarli trips usually involve overnight stays. Tempo Travellers are designed for long-distance travel, offering luggage space, reliable performance, and passenger comfort across highways and coastal roads.'
    },
    {
      title: 'Custom Konkan Travel Itineraries',
      description: 'Each group has unique plans and preferences. Tempo Traveller rentals allow flexible pickup points, customized routes, and adjustable schedules, making it easy to combine Tarkarli with nearby Konkan destinations.'
    }
  ],

  services: [
    {
      name: 'Tempo Traveller Hire for Tarkarli',
      description: 'Sanavi Travels offers dedicated Tempo Traveller hire services for Tarkarli, designed for safe, comfortable, and well-organized group travel. Our fleet includes 12, 16, and 20 seater Tempo Travellers suitable for families, friends, corporate teams, and tourists. Spacious seating, smooth rides, and experienced drivers ensure a stress-free journey through Konkan routes. Transparent pricing, professional coordination, and dependable service make us a preferred choice for Tarkarli trips.'
    },
    {
      name: 'AC Tempo Traveller Tarkarli',
      description: 'AC Tempo Travellers provide enhanced comfort during long coastal journeys. Air-conditioned interiors reduce fatigue, keep passengers relaxed, and make travel pleasant even in warm weather conditions.'
    },
    {
      name: 'Non AC Tempo Traveller Tarkarli',
      description: 'Non-AC Tempo Travellers are a budget-friendly option for groups looking for economical travel without compromising safety or seating comfort.'
    },
    {
      name: '12 Seater Tempo Traveller Tarkarli',
      description: '12 seater Tempo Travellers are ideal for small families or friend groups seeking comfortable and private group travel to Tarkarli.'
    },
    {
      name: '16 Seater Tempo Traveller Tarkarli',
      description: '16 seater Tempo Travellers suit medium-sized groups, offering balanced capacity, comfort, and affordability for beach trips.'
    },
    {
      name: '20 Seater Tempo Traveller Tarkarli',
      description: '20 seater Tempo Travellers are perfect for larger groups, corporate teams, and extended families traveling together to Tarkarli.'
    },
    {
      name: 'Luxury Tempo Traveller Tarkarli',
      description: 'Luxury Tempo Travellers feature upgraded interiors and premium seating, making them suitable for VIP guests, premium tours, and special occasions.'
    },
    {
      name: 'Tempo Traveller for Family Tarkarli',
      description: 'Family-focused services ensure comfort, safety, and convenience for travelers of all age groups during long-distance travel.'
    },
    {
      name: 'Tempo Traveller for Corporate Tarkarli',
      description: 'Corporate Tempo Traveller services support punctual and professional travel for team outings, retreats, and leisure programs.'
    },
    {
      name: 'Tempo Traveller for Group Tarkarli',
      description: 'Group travel services help keep everyone together, simplifying coordination and enhancing the overall travel experience.'
    },
    {
      name: 'Affordable Tempo Traveller Tarkarli',
      description: 'Affordable rental plans allow groups to manage travel budgets efficiently while enjoying reliable and comfortable transportation.'
    },
    {
      name: 'Best Tempo Traveller Service Tarkarli',
      description: 'Sanavi Travels is trusted for consistent service quality, punctuality, and customer satisfaction on Tarkarli routes.'
    },
    {
      name: 'Tempo Traveller with Driver Tarkarli',
      description: 'All Tempo Travellers come with experienced drivers familiar with Konkan highways and coastal roads, ensuring safe and smooth travel.'
    },
    {
      name: 'Tempo Traveller for Wedding Tarkarli',
      description: 'Wedding-related group travel is managed efficiently with organized Tempo Traveller services that reduce logistical stress.'
    },
    {
      name: 'Tempo Traveller for Picnic Tarkarli',
      description: 'Picnic travel services support relaxed group outings with coordinated travel and comfortable seating arrangements.'
    }
  ],

  tableData: [
    ['Tempo Traveller', 'Tarkarli Trip'],
    ['AC', 'Non AC'],
    ['Family', 'Corporate'],
    ['Group Picnic', 'Beach Tour'],
    ['Affordable', 'Luxury Options']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Experienced Konkan Route Drivers',
      WhyChoosedescription: 'Our drivers have extensive experience navigating Konkan coastal roads, ghats, and highways. Their knowledge ensures safe handling of curves, smooth driving, and timely arrivals, providing peace of mind throughout the journey.'
    },
    {
      WhyChooseheading: 'Comfort-Oriented Tempo Travellers',
      WhyChoosedescription: 'Our Tempo Travellers are maintained for long-distance comfort with spacious seating, good legroom, and smooth suspension, keeping passengers relaxed and refreshed.'
    },
    {
      WhyChooseheading: 'Multiple Seating Options',
      WhyChoosedescription: 'We offer 12, 16, and 20 seater options, allowing groups to choose the right vehicle size based on their needs.'
    },
    {
      WhyChooseheading: 'Transparent & Fair Pricing',
      WhyChoosedescription: 'Clear pricing with no hidden charges helps groups plan their Tarkarli trip confidently and stay within budget.'
    },
    {
      WhyChooseheading: 'Clean & Well-Maintained Fleet',
      WhyChoosedescription: 'All vehicles are regularly cleaned, sanitized, and serviced to ensure hygiene, safety, and reliable performance.'
    },
    {
      WhyChooseheading: 'Flexible Scheduling & Pickups',
      WhyChoosedescription: 'Custom pickup points and travel schedules allow the trip to be tailored to group preferences.'
    },
    {
      WhyChooseheading: 'Trusted Outstation Travel Partner',
      WhyChoosedescription: 'Sanavi Travels is known for dependable outstation services and consistent customer satisfaction.'
    },
    {
      WhyChooseheading: 'End-to-End Travel Support',
      WhyChoosedescription: 'From booking to journey completion, our support team ensures smooth coordination and assistance whenever required.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide Tempo Traveller hire for Tarkarli from Pune?',
    answer: 'Yes, Sanavi Travels offers Tempo Traveller hire services from Pune and nearby areas to Tarkarli, including AC, Non-AC, and luxury options for group travel.'
  },
  {
    question: 'Is this service suitable for family trips?',
    answer: 'Yes, our Tempo Travellers are ideal for family travel, offering comfort, safety, and ample space for long journeys.'
  },
  {
    question: 'Are AC Tempo Travellers available?',
    answer: 'Yes, AC Tempo Travellers are available and recommended for long-distance coastal travel.'
  },
  {
    question: 'Can corporate groups book Tempo Travellers for Tarkarli?',
    answer: 'Absolutely. Corporate teams frequently book our Tempo Travellers for retreats, outings, and relaxation trips.'
  },
  {
    question: 'Are drivers experienced with Konkan routes?',
    answer: 'Yes, all drivers are well-trained and experienced with Konkan highways and coastal roads.'
  },
  {
    question: 'Is this suitable for overnight trips?',
    answer: 'Yes, Tempo Travellers are suitable for overnight and multi-day outstation tours.'
  },
  {
    question: 'Can pickup points be customized?',
    answer: 'Yes, pickup locations and timings can be customized based on group requirements.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, we follow transparent pricing with no hidden charges.'
  },
  {
    question: 'Is this service good for picnics and group tours?',
    answer: 'Yes, Tempo Travellers are ideal for picnics, group tours, and leisure trips to Tarkarli.'
  },
  {
    question: 'How early should we book?',
    answer: 'Advance booking is recommended, especially during weekends, holidays, and peak seasons.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Patil',
    feedback: 'We hired a Tempo Traveller from Sanavi Travels for our family trip to Tarkarli, and the experience was excellent. The vehicle was clean, comfortable, and perfect for a long Konkan journey. The driver was polite and very knowledgeable about the route. Traveling together made the trip relaxing and enjoyable. Highly recommended for group travel.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Our friends group booked a Tempo Traveller to Tarkarli with Sanavi Travels. The booking process was smooth, pricing was transparent, and the journey was very comfortable. The driver handled the coastal roads safely, and we reached on time. It was a memorable trip, and we would definitely book again.',
    rating: 5
  }
];






























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire for Tarkarli - Sanavi Travels",
  "description": "Sanavi Travels offers Tempo Traveller hire for Tarkarli trips, including AC and Non-AC options in 12-seater, 16-seater, and 20-seater configurations. Ideal for family trips, corporate travel, group tours, weddings, and picnics with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Tempo Traveller Hire for Tarkarli | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers for Tarkarli trips with Sanavi Travels. AC & Non-AC 12, 16, and 20-seater Tempo Travellers for family trips, corporate travel, group tours, weddings, and picnics with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/298.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhirefortarkari;